import type { GreeningFiveWhys } from '../../services/greeningApi';

export const GREENING_AGENT_LABEL = 'GreeningAI';

/** Referência padrão em frases — sempre «o agente GreeningAI». */
export const GREENING_AGENT_PHRASE = 'o agente GreeningAI';
export const GREENING_AGENT_PHRASE_CAP = 'O agente GreeningAI';

export const GREENING_AGENT_TITLE_PREFIX = 'Análise do Agente de Inteligência';
export const GREENING_AGENT_TITLE = `${GREENING_AGENT_TITLE_PREFIX} ${GREENING_AGENT_LABEL}`;

export const GREENING_DISCLAIMER =
  'Análise de apoio gerada pela GreeningAI; não substitui uma avaliação técnica ou jurídica.';

export const GREENING_CHAT_TITLE = 'Chat com o agente GreeningAI';

export const GREENING_OAAS_CTA =
  'Para operacionalizar uma solução tecnicamente e financeiramente viável a este desafio, a Equipe de Operação OaaS GreenPlat pode apoiar sua empresa na implementação prática.';

export const GREENING_QA_RETENTION_INFO =
  'O histórico de perguntas e respostas neste chat é mantido por até 24 meses, em conformidade com a política de privacidade do projeto. Após esse período, os registros são excluídos ou anonimizados conforme a LGPD.';

export const GREENING_QA_RETENTION_MONTHS = 24;

export const GREENING_CONTACT_EMAIL = 'contato@greenplat.com';

export const GREENING_RATE_LIMIT_MESSAGE =
  'Você atingiu o limite de interações com o agente GreeningAI previsto no seu contrato para o período atual (cota diária de tokens). Novas perguntas estarão disponíveis quando o período for renovado. Para ampliar sua cota, entre em contato com contato@greenplat.com.';

export const GREENING_ANALYSIS_QUESTIONS: Array<{
  key: keyof GreeningFiveWhys;
  label: string;
}> = [
  { key: 'for_government', label: 'O que é a lei para o governo?' },
  { key: 'for_company', label: 'O que é a lei para a empresa?' },
  { key: 'present_changes', label: 'O que muda no presente?' },
  { key: 'past_changes', label: 'O que muda em relação ao passado?' },
  { key: 'future_changes', label: 'O que muda para o futuro?' },
];
